export default "__VITE_ASSET__DZEzbXjx__"